import React from "react"
import { Box, Button, Container, Heading } from "@chakra-ui/react"

import TileCarousel from "@components/TileCarousel/TileCarousel"
import Link from "@components/Link"
import { useRoutes } from "@hooks/useRoutes"
import useSanitySearch from "@hooks/useSanitySearch"
import useSearchSettings from "@hooks/useSearchSettings"
import LearnPageItemMobile from "./LearnPageItemMobile"
import LearnPageItemDesktop from "./LearnPageItemDesktop"

export interface LearnPageItemProps {
  page: NormalisedArticle
}

const LearnPageResults = ({
  titleResults,
  titleNoResults,
  link,
  theme,
  carouselSettingsDesktop,
}: GatsbyTypes.SanitySectionLearnPageResults) => {
  const {
    sanityResults: { learnPages },
  } = useSanitySearch()
  const { suggestions } = useSearchSettings()
  const { urlResolver } = useRoutes()

  const resolvedLink = urlResolver(link)
  const items = learnPages.length ? learnPages : suggestions.learnPages
  const title = learnPages.length ? titleResults : titleNoResults

  return (
    <Box id={`learn-page-results`} bg={theme === "Dark" ? "brand.beige.dark" : "white"} my={4}>
      <Container py={6} textAlign="center">
        <Heading as="h2" size="h2" mb={3}>
          {title}
        </Heading>
        {items.length > 0 && (
          <TileCarousel carouselSettings={carouselSettingsDesktop} navigationProps={{ top: "27%" }}>
            {items.map(page => (
              <Box mb={3.5} key={page.key} w="316px">
                <Box display={["block", "none"]}>
                  <LearnPageItemMobile page={page} />
                </Box>
                <Box display={["none", "block"]}>
                  <LearnPageItemDesktop page={page} />
                </Box>
              </Box>
            ))}
          </TileCarousel>
        )}
        <Button as={Link} to={resolvedLink.url} variant="blue" mt={2.5}>
          {resolvedLink.title}
        </Button>
      </Container>
    </Box>
  )
}

export default LearnPageResults
